// components/Login.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SquareCard from '../specific/loginCard'; // Asegúrate de que la ruta sea correcta
import Footer from '../common/footer';
import { LoginService } from '../../Services/loginService';
import MessagePopUp from '../common/messagePopUp';
import Header from '../common/header';
import { PatchUserService } from '../../Services/userService';
import Cookies from 'js-cookie';
import { useTranslation } from "react-i18next"


function Login() {
  const [t] = useTranslation("login")
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [popupMessage, setPopupMessage] = useState(
    {
      title: t("popupErrorCredentials.title"),
      body: t("popupErrorCredentials.text")
    }
  );
  const [loading, setLoading] = React.useState(false);


  const handleButtonMessageErrorLoginClick = () => {
    setShowPopup(false);
    setShowModal(true);
  };


  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true)
    // Simulación de autenticación (reemplaza con tu lógica real)
    const response = await LoginService(email, password);
    if (response.success) {
      // Crear un objeto para agrupar los valores
      const authInfo = {
        isAuthenticated: true,
        token: response.token,
        environment: response.environment,
        rol: '', // inicializamos como string vacío
        idUser: response.user,
        email: email
      };
      // Configurar el rol basado en el ID de rol en la respuesta
      if (response.rol === "7136f7c7-f668-457b-b143-ddc816a4679d") {
        authInfo.rol = 'admin';
      }
      if (response.rol === "f5bb3630-5c0a-43f5-9188-66c364f67417" || response.rol === "e10260a4-3ff4-42fc-a32b-46637dbfc10b") {
        authInfo.rol = 'responsible';
      }
      if (response.rol === "08807b6d-32ac-4ad1-897d-9af6b0d1075c" || response.rol === "e9325c65-248a-4e30-acca-67b6ecfef23e") {
        authInfo.rol = 'adminResponsible';
      }

      let languageCookie = Cookies.get('myreportin_language');

      const user = {
        language : languageCookie
      }
      await PatchUserService(user, response.user);

      // Convertir el objeto a una cadena JSON y almacenarlo en localStorage
      localStorage.setItem('authInfo', JSON.stringify(authInfo));
      // Navegar basado en el rol
      window.location.href = authInfo.rol === 'admin' ? '/users' : '/incidents';

    } else {
      localStorage.removeItem('authInfo');
      setPopupMessage({ title: response.title, body: response.message })
      setShowPopup(true)
    }
    setLoading(false);
  };

  useEffect(() => {
    localStorage.removeItem("authInfo");
  },[])

  return (
    <div>
      <MessagePopUp
        show={showPopup}
        handleClose={() => setShowPopup(false)}
        title={popupMessage.title}
        textBody={popupMessage.body}
        buttonText={t("popupErrorCredentials.button")}
        onClickButton={handleButtonMessageErrorLoginClick}
      />
      <Header
        translucent
        showUpdate={false}
      />
      <SquareCard
        showLogin={true}
        buttonText={t("loginCard.login")} // Texto del botón
        onSubmit={handleLogin} // Función para manejar el envío
        setEmail={setEmail} // Pasar la función setEmail al componente SquareCard
        setPassword={setPassword} // Pasar la función setPassword al componente SquareCard
        type="login"
        loading={loading}
      />
      <Footer absolutePosition />
    </div>
  );
}

export default Login;